import React from 'react';
import ContentLoader from 'react-content-loader';

const UserViewLoader = () => {
  return (
    <ContentLoader
      speed={2}
      width={1463}
      height={744}
      viewBox="0 0 1463 744"
      backgroundColor='#f3f3f3'
      foregroundColor='#ecebeb'>
      <>
        <rect x="28" y="26" rx="3" ry="3" width="176" height="12" />
        <rect x="28" y="75" rx="3" ry="3" width="250" height="20" />
        <rect x="28" y="114" rx="3" ry="3" width="89" height="8" />

        <rect x="28" y="481" rx="3" ry="3" width="46" height="8" />
        <rect x="253" y="115" rx="3" ry="3" width="89" height="8" />
        <rect x="367" y="116" rx="3" ry="3" width="46" height="8" />
        <rect x="28" y="133" rx="3" ry="3" width="89" height="8" />
        <rect x="28" y="174" rx="3" ry="3" width="89" height="8" />
        <rect x="253" y="133" rx="3" ry="3" width="89" height="8" />
        <rect x="180" y="136" rx="3" ry="3" width="46" height="8" />
        <rect x="367" y="133" rx="3" ry="3" width="46" height="8" />
        <rect x="28" y="196" rx="3" ry="3" width="89" height="8" />
        <rect x="28" y="242" rx="3" ry="3" width="250" height="20" />

        <rect x="28" y="282" rx="3" ry="3" width="89" height="8" />
        <rect x="28" y="308" rx="3" ry="3" width="89" height="8" />
        <rect x="28" y="353" rx="3" ry="3" width="89" height="8" />
        <rect x="28" y="375" rx="3" ry="3" width="89" height="8" />
        <rect x="28" y="440" rx="3" ry="3" width="250" height="20" />

        <rect x="1200" y="74" rx="3" ry="3" width="250" height="20" />
        <rect x="1160" y="78" rx="3" ry="3" width="19" height="12" />
        <rect x="1160" y="240" rx="3" ry="3" width="19" height="15" />
        <rect x="1200" y="239" rx="3" ry="3" width="250" height="20" />
        <rect x="1160" y="439" rx="3" ry="3" width="19" height="15" />
        <rect x="1200" y="438" rx="3" ry="3" width="250" height="20" />

        <rect x="179" y="115" rx="3" ry="3" width="46" height="8" />
        <rect x="28" y="504" rx="3" ry="3" width="89" height="8" />
        <rect x="145" y="482" rx="3" ry="3" width="89" height="8" />
        <rect x="146" y="503" rx="3" ry="3" width="158" height="8" />
        <rect x="28" y="547" rx="3" ry="3" width="89" height="8" />
        <rect x="151" y="547" rx="3" ry="3" width="89" height="8" />
        <rect x="263" y="545" rx="3" ry="3" width="126" height="8" />
        <rect x="28" y="572" rx="3" ry="3" width="89" height="8" />
        <rect x="153" y="573" rx="3" ry="3" width="89" height="8" />
        <rect x="264" y="574" rx="3" ry="3" width="89" height="8" />
      </>
    </ContentLoader>
  );
};

export default UserViewLoader;
